module.exports = __webpack_public_path__ + "static/img/核心4.3aa9bf3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index/核心4.png
// module id = 8aPf
// module chunks = 1